import React from "react";
import HomeVideo from "./components/HomeVideo";
import Home from "./components/Home";
import Festival from "./components/Festival";
import Tickets from "./components/Tickets";
import LineUp from "./components/LineUp";
import Media from "./components/Media";
import About from "./components/About";
import FAQ from "./components/FAQ";
import ContactUs from "./components/ContactUs";
import Sponsors from "./components/Sponsors";
import Terms from "./components/Terms"
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";




document.addEventListener("DOMContentLoaded", function () {
    // Get the navbar toggler and the collapse element
    const navbarToggler = document.querySelector(".navbar-toggler");
    const navbarCollapse = document.querySelector("#navbarSupportedContent");
  
    // Add a click event listener to the document to handle outside clicks
    document.addEventListener("click", function (event) {
        // Check if the click is outside the navbar toggler and the collapse menu
        if (!navbarToggler.contains(event.target) && !navbarCollapse.contains(event.target)) {
            // If the collapse menu is open, close it
            if (navbarCollapse.classList.contains("show")) {
                closeNavbar();
            }
        }
    });
  
    // Add a click event listener to the navbar links to close the menu when a link is clicked
    const navbarLinks = document.querySelectorAll("#navbarSupportedContent .nav-link");
    navbarLinks.forEach(link => {
        link.addEventListener("click", () => {
            if (navbarCollapse.classList.contains("show")) {
                closeNavbar();
            }
        });
    });
  
    // Add a click event listener to the navbar toggler to handle smooth transitions
    navbarToggler.addEventListener("click", function () {
        if (navbarCollapse.classList.contains("show")) {
            // If the menu is open, close it
            closeNavbar();
        } else {
            // If the menu is closed, open it
            openNavbar();
        }
    });
  
    // Function to open the navbar with smooth transition
    function openNavbar() {
        navbarCollapse.style.height = "0"; // Start from height 0
        navbarCollapse.classList.add("show");
        requestAnimationFrame(() => {
            navbarCollapse.style.height = `${navbarCollapse.scrollHeight}px`; // Animate to full height
            setTimeout(() => {
                navbarCollapse.style.height = ""; // Reset height to auto
            }, 350); // Match the transition duration
        });
    }
  
    // Function to close the navbar with smooth transition
    function closeNavbar() {
        navbarCollapse.style.height = `${navbarCollapse.scrollHeight}px`; // Set height to current height
        requestAnimationFrame(() => {
            navbarCollapse.classList.add("collapsing");
            navbarCollapse.style.height = "0"; // Animate height to 0
            setTimeout(() => {
                navbarCollapse.classList.remove("collapsing");
                navbarCollapse.classList.remove("show");
                navbarCollapse.style.height = ""; // Reset height
            }, 350); // Match the transition duration
        });
    }
  });

function App() {

    return (
        <div>
            <HomeVideo />
            <Home />
            <Festival />
            <Tickets />
            <LineUp />
            <Media />
            <About />
            <FAQ />
            <ContactUs />
            <Sponsors />
            <Terms />
        </div>
    );
}

export default App;

export {
  HomeVideo,
  Home,
  Festival,
  Tickets,
  LineUp,
  Media,
  About,
  FAQ,
  ContactUs,
  Sponsors,
  Terms,
}
